import { toHTML } from "@portabletext/to-html";
import {
  CopyColumnProps,
  ExpandedKeyValueListProps,
} from "@bluebottlecoffee/design-system/components";
import type { BulletedKeyValue } from "@bluebottlecoffee/design-system/components/lib/types";
import { isHomePage, stripHtmlTags } from "../utils";
import {
  CopyColumn as CopyColumnSchema,
  ExpandedKeyValueList,
  CopyColumnFreeFlow,
} from "../sanity-schema";
import { toLinkProps } from "./link";
import { trackEvent } from "../segment/track-event";

function toExpandedKeyValueListProps(
  data: ExpandedKeyValueList,
  locale: string,
): ExpandedKeyValueListProps {
  if (!data) return undefined;

  return {
    hasTopBorders: data.hasTopBorders,
    keyValues: data.keyValueList.map(
      (kv) =>
        ({
          key: kv.key[locale],
          value: toHTML(kv.value[locale]),
        }) as BulletedKeyValue,
    ),
  };
}

export function toCopyColumnProps(
  data: CopyColumnSchema | CopyColumnFreeFlow,
  region: string,
  lang: string,
): CopyColumnProps {
  const subheading =
    data.copyBlock?.subheading && toHTML(data.copyBlock.subheading[lang]);

  return {
    ...(data.cta?.text && {
      cta: {
        ...toLinkProps(data.cta, region, lang),
        onClick: () => {
          if (isHomePage(lang, region)) {
            trackEvent("homepage_cta", {
              heading:
                (data.copyBlock?.heading && data.copyBlock.heading[lang]) ||
                stripHtmlTags(subheading ?? ""),
              cta_name: data.cta.text[lang],
            });
          }
        },
      },
    }),
    ...(data._type === "copyColumnFreeFlow" &&
      data.hasYMargins && {
        hasYMargins: data.hasYMargins,
      }),
    copyBlockProps: {
      ...(data.cta && { smallText: true }),
      heading: data.copyBlock?.heading && data.copyBlock.heading[lang],
      subheading,
      description:
        data.copyBlock?.description && toHTML(data.copyBlock.description[lang]),
    },
    keyValueListProps: toExpandedKeyValueListProps(
      data.keyValueList?.[0],
      lang,
    ),
  };
}
